class API {
  constructor (serialWrapper, lock) {
    this.serialWrapper = serialWrapper
    this.lock = lock
  }

  async print (data) {
    await this.lock.acquire()

    try {
      const writer = this.serialWrapper.port.writable.getWriter()
      await writer.write(data)
      writer.releaseLock()
    } catch (error) {
      console.log(error)
    } finally {
      this.lock.release()
    }

    return new Promise(function (resolve) {
      resolve()
    })
  }
}

export default API
